import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";

const H0 = 6, H1 = 20, SPAN = H1 - H0;
const pct = (t) => { const [h, m] = t.split(":").map(Number); return Math.max(0, Math.min(100, ((h + m / 60 - H0) / SPAN) * 100)); };

export default function Coactivite() {
  const { zones, labels, selectedSite } = useApp();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [autos, setAutos] = useState([]);
  const today = new Date().toISOString().slice(0, 10);

  useEffect(() => {
    api.get("/coactivite").then((r) => setData(r.data));
    api.get("/autorisations").then((r) => setAutos(r.data));
  }, []);

  const planZones = useMemo(() => selectedSite === "all" ? zones : zones.filter((z) => z.siteId === selectedSite), [zones, selectedSite]);
  if (!data) return <div className="mono">Chargement…</div>;

  const conflictIds = new Set(data.conflits.flatMap((c) => [c.a, c.b]));
  const todaysAutos = autos.filter((a) => a.date === today);
  const verdictCls = { compatible: "b-autorise", sous_conditions: "b-soumis", incompatible: "b-incompatible" };

  return (
    <div>
      <div className="crumb">Moteur de coactivité · {new Date().toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" })}</div>
      <h1>Coactivité</h1>

      <h2 style={{ fontSize: "1.1rem", margin: "8px 0 10px" }}>Incompatibilités détectées</h2>
      {data.conflits.length ? data.conflits.map((c) => (
        <div className={`conf ${c.niv === "warn" ? "warn" : ""}`} key={c.key} data-testid={`coact-conflict-${c.code}`}>
          <div className="t"><span className="mono">{c.code}</span> · {c.a} × {c.b} · {c.niv === "stop" ? "Incompatible" : "Sous conditions"}</div>
          <div className="d">{c.msg}</div>
          <div className="fix">→ {c.fix}</div>
        </div>
      )) : <div className="card" style={{ borderLeft: "4px solid var(--vert)" }}>Aucune incompatibilité de coactivité détectée aujourd'hui.</div>}

      <h2 style={{ fontSize: "1.1rem", margin: "18px 0 10px" }}>Verdict par intervention</h2>
      <div className="tablewrap" style={{ marginBottom: 16 }}><table>
        <thead><tr><th style={{ width: 90 }}>Réf.</th><th>Entreprise</th><th>Zone</th><th style={{ width: 120 }}>Horaires</th><th style={{ width: 200 }}>Verdict</th></tr></thead>
        <tbody>
          {data.verdicts.length ? data.verdicts.map((v) => (
            <tr className="click" key={v.id} onClick={() => nav(`/autorisations/${v.id}`)} data-testid={`verdict-row-${v.id}`}>
              <td className="mono">{v.id}</td><td>{v.entNom}</td><td>{v.zone}</td><td className="mono">{v.deb}–{v.fin}</td>
              <td><span className={`badge ${verdictCls[v.verdict]}`}>{v.verdictLabel}</span>{v.nbStop > 0 && <span style={{ marginLeft: 8, fontSize: ".72rem", color: "var(--rouge)" }}>{v.nbStop} bloquant(s)</span>}</td>
            </tr>
          )) : <tr><td colSpan={5} className="empty">Aucune intervention aujourd'hui.</td></tr>}
        </tbody>
      </table></div>

      <h2 style={{ fontSize: "1.1rem", margin: "18px 0 10px" }}>Planning par zone (aujourd'hui)</h2>
      <div className="plan-wrap"><div className="plan">
        <div className="plan-hours"><div /><div className="scale">{Array.from({ length: 8 }, (_, i) => { const h = H0 + i * 2; return <span key={h} style={{ left: `${((h - H0) / SPAN) * 100}%` }}>{h}h</span>; })}</div></div>
        {planZones.map((z) => {
          const azs = todaysAutos.filter((a) => a.zone === z.id);
          return (
            <div className="plan-row" key={z.id}>
              <div className="plan-zone">{z.nom}<div className="attrs">{z.attributs.map((a) => labels.attrs[a]).join(" · ") || "—"}</div></div>
              <div className="plan-track">
                {azs.map((a) => {
                  const l = pct(a.deb), w = Math.max(4, pct(a.fin) - l);
                  return <div key={a.id} className={`blk ${a.statut} ${conflictIds.has(a.id) ? "conflit" : ""}`} style={{ left: `${l}%`, width: `${w}%` }}
                    onClick={() => nav(`/autorisations/${a.id}`)} title={`${a.id} · ${a.entNom}`}>{a.id} {a.deb}–{a.fin}</div>;
                })}
              </div>
            </div>
          );
        })}
      </div>
        <div className="legend">
          <span><i style={{ background: "var(--sarcelle)" }} />Démarré</span>
          <span><i style={{ background: "var(--vert)" }} />Autorisé</span>
          <span><i style={{ background: "var(--ambre)" }} />Soumis / en validation</span>
          <span><i style={{ background: "var(--rouge)" }} />Suspendu</span>
          <span><i style={{ background: "#fff", border: "2px solid var(--rouge)" }} />En conflit</span>
        </div>
      </div>
    </div>
  );
}
